import {IBlog, IBlogsResponse, IBlogState, initialBlogsState, initialBlogState} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {createBlog, deleteBlog, getBlogById, getBlogs, updateBlog} from "./ActionCreators";

const initialValue: IBlogState = {
    fetchBlogsLoading: false,
    items: initialBlogsState,
    fetchBlogLoading: false,
    item: initialBlogState,
    actionLoading: false,
}

const blogSlice = createSlice({
    name: SliceNames.BLOG,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getBlogs.pending, (state) => {
                state.fetchBlogsLoading = true
            })
            .addCase(
                getBlogs.fulfilled, (state, action: PayloadAction<IBlogsResponse>) => {
                    state.items = action.payload
                    state.fetchBlogsLoading = false
                })
            .addCase(
                getBlogs.rejected, (state) => {
                    state.items = initialBlogsState
                    state.fetchBlogsLoading = false
                })
            .addCase(
                getBlogById.pending, (state) => {
                    state.fetchBlogLoading = true
                })
            .addCase(
                getBlogById.fulfilled, (state, action: PayloadAction<IBlog>) => {
                    state.item = action.payload
                    state.fetchBlogLoading = false
                })
            .addCase(
                getBlogById.rejected, (state) => {
                    state.fetchBlogLoading = false
                })
            .addCase(
                deleteBlog.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                deleteBlog.fulfilled, (state, action: PayloadAction<any>) => {
                    state.items = {
                        count: state.items.count - 1,
                        total_pages: state.items.total_pages,
                        data: [...state.items.data].filter(c => c.id !== action.payload)
                    }
                    state.actionLoading = false
                })
            .addCase(
                deleteBlog.rejected, (state) => {
                    state.actionLoading = false
                })
            .addCase(
                createBlog.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                createBlog.fulfilled, (state, action: PayloadAction<IBlog>) => {
                    state.items = {
                        count: state.items.count + 1,
                        total_pages: state.items.total_pages,
                        data: [action.payload, ...state.items.data]
                    }
                    state.actionLoading = false
                })
            .addCase(
                createBlog.rejected, (state) => {
                    state.actionLoading = false
                })
            .addCase(
                updateBlog.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                updateBlog.fulfilled, (state, action: PayloadAction<IBlog>) => {
                    state.items = {
                        ...state.items,
                        data: state.items.data.map(el => (el.id === action.payload.id ? {...el, ...action.payload} : el))
                    }
                    state.actionLoading = false
                })
            .addCase(
                updateBlog.rejected, (state) => {
                    state.actionLoading = false
                })
    }
})

export default blogSlice.reducer

